// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3QU0X","image":"Header_image__6g-6n","name":"Header_name__1-EzB","info":"Header_info__1nJWM","infoRow":"Header_infoRow__3vjQk"};